export default "__VITE_ASSET__DBdl7WdD__"